import {createSlice} from '@reduxjs/toolkit';
import {toast} from 'react-toastify';
import {INPUT_FIELD, RADIO_FIELD} from '../fields/staticData';

const initialState = {
  data: {
    label: '',
    fields: [
      {
        id: 1,
        ...INPUT_FIELD,
      },
    ],
  },
  active_field: 0,
};

const createFormSlice = createSlice({
  name: 'createForm',
  initialState,
  reducers: {
    setDefaultState(state, action) {
      state.data = {
        label: '',
        fields: [
          {
            id: 1,
            ...INPUT_FIELD,
          },
        ],
      };
      state.active_field = 0;
    },
    setMainLabel(state, action) {
      state.data.label = action.payload;
    },
    setRequired(state, action) {
      const {idx} = action.payload;
      state.data.fields[idx].required = !state.data.fields[idx].required;
    },
    setAllData(state, action) {
      state.data = action.payload;
    },
    setFields(state, action) {
      let {
        index,
        parentIndex,
        key,
        value,
        nestingKey,
        acceptable = false,
      } = action.payload;

      if (!nestingKey && !parentIndex && key) {
        state.data.fields[index][key] = value;
      } else if (acceptable && !key) {
        state.data.fields[parentIndex][nestingKey][index] = value;
      } else if (!key && !acceptable) {
        state.data.fields[parentIndex][nestingKey] = value;
      } else {
        state.data.fields[parentIndex][nestingKey][index][key] = value;
      }
    },
    addField(state, action) {
      const {field} = action.payload;

      state.data.fields = [...state.data.fields, field];
      state.active_field = state.data.fields.length - 1;
    },
    deleteField(state, action) {
      const idx = action.payload;
      if (idx) {
        state.data.fields = state.data.fields.filter(
          (field, index) => index !== Number(idx),
        );
      } else {
        toast.error('Field is not defined');
      }
    },
    deleteOption(state, action) {
      const {parentIndex, key, index} = action.payload;

      state.data.fields[parentIndex][key] = state.data?.fields[parentIndex][
        key
      ]?.filter((item, tIndex) => tIndex !== index);
    },
    addOption(state, action) {
      const {parentIndex, option, key} = action.payload;

      state.data.fields[parentIndex][key] = [
        ...state.data.fields[parentIndex][key],
        option,
      ];
    },
    setActiveField(state, action) {
      const {idx} = action.payload;

      state.active_field = idx;
    },
    setFieldType(state, action) {
      const {idx, field} = action.payload;
      state.data.fields[idx] = field;
    },
    setDrag(state, action) {
      state.data.fields = action.payload;
    },
    setFieldsId(state, action) {
      state.data.fields = state.data.fields?.map((field, index) => {
        field.id = index + 1;
        return field;
      });
    },
  },
});

export const {
  setMainLabel,
  setFields,
  addField,
  deleteField,
  deleteOption,
  addOption,
  setActiveField,
  setFieldType,
  setDrag,
  setFieldsId,
  setAllData,
  setDefaultState,
  setRequired,
} = createFormSlice.actions;

export default createFormSlice.reducer;
